import React from "react";

const reportWebVitals = () => {
  return <div>reportWebVitals</div>;
};

export default reportWebVitals;
